import { isOrder, orderHasVoucher } from "../orders/is-order";
import type { Order } from "../orders/order";
import { isOrderItemVoucher_V1 } from "../orders/order-items/is-order-item-v1";
import { isOrderItemVoucher_V2 } from "../orders/order-items/is-order-item-v2";
import type {
    OrderItem,
    OrderItemVoucher,
} from "../orders/order-items/order-item";
import type {
    OrderItemVoucher_V1,
    OrderItem_V1,
} from "../orders/order-items/order-item-v1";
import type {
    OrderItemVoucher_V2,
    OrderItem_V2,
} from "../orders/order-items/order-item-v2";
import type { Content } from "../pages/content/content";
import { isProduct } from "../products/is-product";
import type { Product, Voucher_Product } from "../products/product";
import type { Sku, VoucherSku} from "../products/sku";
import { isVoucherSku } from "../products/sku";
import type { Acquirable} from "./acquirable";
import { isAcquirable } from "./acquirable";
import type { Voucher } from "./voucher";

function isVoucher(order: Order): boolean;
function isVoucher(orderItem: OrderItem_V1): orderItem is OrderItemVoucher_V1;
function isVoucher(orderItem: OrderItem_V2): orderItem is OrderItemVoucher_V2;
function isVoucher(orderItem: OrderItem): orderItem is OrderItemVoucher;
function isVoucher(product: Product | undefined): product is Voucher_Product;
function isVoucher(acquirable: Acquirable): acquirable is Voucher;
function isVoucher(sku: Sku): sku is VoucherSku;
function isVoucher(content: Content | undefined): boolean;
function isVoucher(
    value:
        | Acquirable
        | Product
        | Sku
        | Order
        | OrderItem_V2
        | OrderItem_V1
        | Content
        | undefined,
): boolean {
    if (typeof value === "undefined") return false;
    if (isVoucherSku(value)) return true;
    if (isOrderItemVoucher_V1(value)) return true;
    if (isOrderItemVoucher_V2(value)) return true;
    if (isAcquirable(value) && value._type === "VOUCHER") return true;
    if (isProduct(value) && value.acquirableAs === "VOUCHER") return true;
    if (isOrder(value) && orderHasVoucher(value)) return true;
    return false;
}

export { isVoucher };
